import React from "react";
import "./ExecutionApproachBlock.css";

function ExecutionApproachBlock({ title, pillars }) {
  return (
    <section className="block block14">

      <h2 className="block14-title">{title || ''}</h2>

      <div className="block14-grid">
        {(pillars || []).map((pillar, index) => (
          <div key={index} className="pillar-card">
            {pillar.icon && <img src={pillar.icon} alt={pillar.title || ''} />}
            <h3>{pillar.title || ''}</h3>
            <p>{pillar.description || ''}</p>
          </div>
        ))}
      </div>

    </section>
  );
}

export default ExecutionApproachBlock;
